// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class BusinessRejectMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_BUSINESS_REJECT_MESSAGE, fieldSet);
    }
    getReferanceMessageId() {
        return this.getFieldValue(FieldsFactory.FIELD_ID);
    }
    setReferanceMessageId(id) {
        this.setFieldValue(FieldsFactory.FIELD_ID, id);
    }
    getComment() {
        return this.getFieldValue(FieldsFactory.FIELD_COMMENT);
    }
    setComment(comment) {
        this.setFieldValue(FieldsFactory.FIELD_COMMENT, comment);
    }
    getErrorCode() {
        return this.getFieldValue(FieldsFactory.FIELD_ERROR_CODE);
    }
}
BusinessRejectMessage.REQUEST_CODE_IS_NOT_SUPPORTED = 39;
BusinessRejectMessage.NO_PRICE_AVAILABLE = 141;
BusinessRejectMessage.TICKER_FOR_SUBSCRIPTION_NOT_EXIST = 340;
BusinessRejectMessage.ERROR_SERVER_HISTORY_QUEUE_WAS_OVERFLOWED = 414;
BusinessRejectMessage.NO_TRADES_OCCURING_CURRENT_DAY = 452;
BusinessRejectMessage.OPTION_EXERCISE_ONLY_ITM = 475;
